(function () {
  console.log("Custom script loaded!");
})();

// Fix: product_type tag buttons behave as radio buttons (capture phase)
document.addEventListener('change', function(e) {
  if (
    e.target.type === 'checkbox' &&
    e.target.name === 'filter.p.product_type' &&
    e.target.checked
  ) {
    document.querySelectorAll(
      'input[type="checkbox"][name="filter.p.product_type"]'
    ).forEach(function(other) {
      if (other !== e.target) {
        other.checked = false;
        other.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}, true);
